<div layout-centered-y margin-bottom-small>
  <rt-heading variant="subheading dark large" margin-right-small-x>{{ title }}</rt-heading>
  <rt-badge *ngIf="showCounter" variant="counter white-bg" margin-right-small-x>{{
    applications.length
  }}</rt-badge>
  <rt-icon
    *ngIf="tooltipText"
    [rtTooltip]="tooltipText"
    [rtTooltipHasTextAlignCenter]="true"
    [rtTooltipMaxWidth]="320"
    name="help-outline"
    margin-right-small-x
  >
  </rt-icon>
  <rt-icon
    *ngIf="collapseEnabled"
    (click)="collapseList()"
    [class.active]="!isCollapsed"
    class="collapse-icon"
    name="keyboard-arrow-down"
  ></rt-icon>
</div>
<div class="applications-list" [@collapse]="isCollapsed ? 'collapsed' : 'normal'">
  <rtr-referrals-card
    *ngFor="let application of applications; trackBy: trackById"
    [application]="application"
    [showStatus]="showStatus"
    [rewardsVisible]="rewardsVisible"
    [statusTranslationsMap]="statusTranslationsMap"
    [type]="type"
    (referralSelect)="openDialog($event)"
  ></rtr-referrals-card>
</div>

<rt-divider *ngIf="isCollapsed"></rt-divider>
